import engine from 'store/src/store-engine';
import allStorages from 'store/storages/all';
import observePlugin from 'store/plugins/observe';

// create store
export const store = engine.createStore(allStorages, [observePlugin]);

// if (process.env.REACT_APP_ENV === 'local') {
//   console.log('Init store logs');
//
//   store.each((value, key) => {
//     store.observe(key, (prev, current) => {
//       console.log('--------');
//       console.log(`${key} is changed`);
//       console.log('From: ', prev);
//       console.log('To: ', current);
//     });
//   });
// }

export default store;
